import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './auth.css';

export function OAuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithTokens, isAuthenticated } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    const handleCallback = async () => {
      const accessToken = searchParams.get('access_token');
      const refreshToken = searchParams.get('refresh_token');
      const errorParam = searchParams.get('error');

      if (errorParam) {
        setError(errorParam);
        setIsProcessing(false);
        return;
      }

      if (!accessToken || !refreshToken) {
        setError('Invalid OAuth callback: missing tokens');
        setIsProcessing(false);
        return;
      }

      try {
        await loginWithTokens(accessToken, refreshToken);
        navigate('/', { replace: true });
      } catch (err) {
        const message = err instanceof Error ? err.message : 'OAuth authentication failed';
        setError(message);
        setIsProcessing(false);
      }
    };

    handleCallback();
  }, [searchParams, loginWithTokens, navigate]);

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated && !isProcessing) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, isProcessing, navigate]);

  if (error) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h1>Authentication Failed</h1>
          <div className="auth-error">{error}</div>
          <button
            onClick={() => navigate('/login')}
            className="auth-button"
            style={{ marginTop: '1rem' }}
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>Completing Sign In...</h1>
        <p className="auth-subtitle">Please wait while we complete your authentication.</p>
        <div className="oauth-loading">
          <div className="oauth-spinner"></div>
        </div>
      </div>
    </div>
  );
}
